module.exports = __webpack_public_path__ + "img/cw_yf_yingFuDuiZhang.e65cefed.svg";